/**
 * Created by Ning Jiang on 3/31/2020.
 */

import {SlideShowPage} from "@nolimitcity/slot-launcher/bin/gui/views/slideshow/SlideShowPage";
import {Texture} from "pixi.js";
import {ImgLoader} from "@nolimitcity/slot-launcher/bin/loader/ImgLoader";
import {GuiDefaults} from "@nolimitcity/slot-launcher/bin/gui/default/GuiDefaults";

export class ImmortalFruitSliderView extends SlideShowPage {
    private titleStyle:PIXI.TextStyle = new PIXI.TextStyle({
        fill : GuiDefaults.INTRO_PAGE_TEXT.fill,
        fontFamily : GuiDefaults.INTRO_PAGE_TEXT.fontFamily,
        fontSize : <number>GuiDefaults.INTRO_PAGE_TEXT.fontSize ,
        fontStyle : GuiDefaults.INTRO_PAGE_TEXT.fontStyle,
        fontWeight : GuiDefaults.INTRO_PAGE_TEXT.fontWeight,
        wordWrap : GuiDefaults.INTRO_PAGE_TEXT.wordWrap,
        wordWrapWidth : GuiDefaults.INTRO_PAGE_TEXT.wordWrapWidth,
        breakWords: GuiDefaults.INTRO_PAGE_TEXT.breakWords
    });
    constructor(textures: string, textString:string,backgroundColor:any) {
        super(undefined, undefined,backgroundColor);

        const imageLeft = new PIXI.Sprite(ImgLoader.getImgTexture(textures));
        imageLeft.anchor.x = 1;
        imageLeft.anchor.y = 0.5;
        // if(textures=="feature1"){
        //     imageLeft.scale.set(1,1);
        //     imageLeft.position.x = imageLeft.width/4-110;
        // }else{
        //     imageLeft.position.x = imageLeft.width/4-70;
        // }


        const right = new PIXI.Graphics();
       // right.beginFill([0x640c84, 0x440458],1);
        right.beginFill(0x640c84,1);
        right.drawRect(0, 0, 1680, 397);
        right.endFill();
        right.pivot.x = 0.5;
        right.pivot.y = 0.5;
        right.position.x = 0;

       // this.addChild(right);
        this.addChild(imageLeft);
        const textField = new PIXI.Text(textString,this.titleStyle);
        textField.anchor.x = 0;// ? 0 : 1;
        textField.anchor.y = 0.6;
        if(textures=="feature1"){
            imageLeft.scale.set(1);
            imageLeft.position.x = imageLeft.width/4-70;
            textField.anchor.y = 0.72;
        }else{
            imageLeft.position.x = imageLeft.width/4-70;
            textField.anchor.y = 0.5;
        }
        //textField.position.x = textField.width/3+15;
        this.addChild(textField);
        //GuiLayout.align([textField], 200, Align.CENTER, Direction.HORIZONTAL);
    }

}